import React from 'react';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Storage from 'utils/storage';
import Setting from 'ui-component/icons/setting';
import { LANGUAGE } from 'constants/common';
import { Divider, Space } from 'antd';
import ZhIcon from 'ui-component/icons/zh';
import EnIcon from 'ui-component/icons/en';
import Avatar from './avatar';
import { useStyles } from './index.style';

const CMP = () => {
  const navigate = useNavigate();
  const { styles } = useStyles();
  const { t, i18n } = useTranslation('common');

  const changeLanguage = (e: any) => {
    i18n.changeLanguage(e);
    Storage.set(LANGUAGE, e, true);
  };

  return (
    <Space split={<Divider type="vertical" />} style={{ paddingRight: '50px' }}>
      <Space size="small">
        {i18n.language === 'en' ? (
          <div onClick={() => changeLanguage('zh')}>
            <ZhIcon width="20px" height="20px" className={styles.language} />
          </div>
        ) : (
          <div onClick={() => changeLanguage('en')}>
            <EnIcon width="20px" height="20px" className={styles.language} />
          </div>
        )}

        <Button shape="circle" className={styles.noBorder} onClick={() => navigate('/account/setting')}>
          <Tooltip title="账户设置">
            <Setting width={20} height={20} />
          </Tooltip>
        </Button>
      </Space>
      <Avatar />
    </Space>
  );
};

export default CMP;
